import axios from 'axios'

export const DASHBOARD_URL = `${process.env.REACT_APP_API_URL}/dashboard`

export type DashboardStatisticsFilter = {
  timePeriod?: string;
  from?: Date | string;
  to?: Date | string;
  chargerType?: string;
  chargerStatus?: string;
  siteId?: number;
  siteIds?: number[];
}

export type DashboardChartMetric = 'activeKwh' | 'completedSessions' | 'revenueShare' | 'totalEnergy' | 'utilisationRate' | 'co2Emissions'

export type DashboardReportType = 'energyUsage' | 'chargingSessions' | 'chargingSessionsPerToken' | 'revenue' | 'revenueSummary'
export type DashboardChartViewMode = 'consolidated' | 'detailed'

export type DashboardChartDataFilter = DashboardStatisticsFilter & {
  metric?: DashboardChartMetric;
  reportType?: DashboardReportType;
  viewMode?: DashboardChartViewMode;
}

export type DashboardChartDataPoint = {
  date: string;
  value: number;
  seriesKey?: string;
  seriesName?: string;
  serverOffsetMinutes?: number;
}

export type SessionDataModel = {
  sessionId: string;
  chargePointId: string;
  idTag: string;
  contractId: string;
  locationName: string;
  sessionStart: string;
  sessionEnd: string;
  roaming: string;
  price: number;
  kwH: number;
}

export type DashboardSyncState = {
  componentName: string;
  syncStatus: string;
}

export const getStatistics = async (filter: DashboardStatisticsFilter) => {
  const response = await axios.post(`${DASHBOARD_URL}/getstatistics`, filter)
  return response
}

export const getChartData = async (filter: DashboardChartDataFilter) => {
  const response = await axios.post<DashboardChartDataPoint[]>(`${DASHBOARD_URL}/getchartdata`, filter)
  return response
}

export const getSessionData = async (filter: DashboardChartDataFilter) => {
  const response = await axios.post<SessionDataModel[]>(`${DASHBOARD_URL}/getsessiondata`, filter)
  return response
}

export const downloadReportPdf = async (filter: DashboardChartDataFilter) => {
  const response = await axios.post(`${DASHBOARD_URL}/downloadreportpdf`, filter, {
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf',
    },
  })
  return response
}

export const downloadReportExcel = async (filter: DashboardChartDataFilter) => {
  const response = await axios.post(`${DASHBOARD_URL}/downloadreportexcel`, filter, {
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  })
  return response
}

export const syncStatistics = async () => {
  // POST to /dashboard/sync endpoint
  return axios.post(`${DASHBOARD_URL}/sync`)
}

export const getSessionSyncState = async () => {
  const response = await axios.get<DashboardSyncState>(`${DASHBOARD_URL}/syncsessions/state`)
  return response
}

export const syncSessionStatistics = async () => {
  try {
    const syncStateResponse = await getSessionSyncState()
    if (syncStateResponse.data?.syncStatus === 'InProgress') {
      return null
    }

    return await axios.post(`${DASHBOARD_URL}/syncsessions`)
  } catch {
    return null
  }
}
